/**
 * `/quality/styles/$styleId/qc` — Quality Control tab of the Style File,
 * but addressed by the module that owns the workflow per issue #156 rule 4.
 * The Style identity stays in the path; the shell + tab content are the
 * same as `/merchandising/styles/$styleId/...`.
 *
 * @see docs/product/garment-os-screen-build-plan.md §A
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { StyleQcPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/quality/styles/$styleId/qc")({
  component: StyleQcRoute,
});

function StyleQcRoute() {
  const { styleId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Quality", to: "/" },
        { label: "Style files", to: "/merchandising/styles" },
        { label: "Quality Control" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <StyleQcPage styleId={styleId} />
    </WorkspaceShell>
  );
}
